import gql from 'graphql-tag';

export const DOCU_SIGN_TAB_MAPPINGS = gql`
  query ($input: DocuSignTabMappingsInput!) {
    docuSignTabMappings(input: $input) {
      label
      type
      trnsactSource
      trnsactSourceDisplayName
      value
      required
    }
  }
`;
